var map = {
	"./music-instructions.json": 4779,
	"./music-library-intro2024.json": 4780,
	"./music-library-launch2024.json": 4781,
	"./music-progression.json": 4782,
	"./startSourcesAdvanced.json": 4783,
	"./startSourcesSimple.json": 4784,
	"./startSourcesSimple2.json": 4785,
	"./startSourcesTracks.json": 4786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4497;